export const getRiskToPathName = (t = {}) => {
    const busCode = t.busCode || t.businessCode;
    const busId = t.busId || t.businessKey;
    if (!busCode) {
        return '';
    }
    if (busCode.indexOf('riskWarning1010') > -1) {
        //  指标配置
        return `/scm-warning/config/search/detail?id=${busId}`;
    }
    if (busCode.indexOf('settle1030') > -1) {
        // 结算
        if (busCode.indexOf('riskWarning1020') > -1) {
            //  预警规则
            return `/scm-settle/risk/config-search/detail?id=${busId}`;
        }
        if (busCode.indexOf('riskWarning1030') > -1) {
            // 预警记录
            return `/scm-settle/risk/log-search/detail?id=${busId}`;
        }
        if (busCode.indexOf('riskWarning1040') > -1) {
            // 预警函
            return `/scm-settle/risk/letter-search/detail?id=${busId}`;
        }
    }
};
